import {Model} from '@/models/Model'
import {DataPromotionsArray} from '@/models/Promotion'
import {DataArray, DataResource, FilterSet} from '@/models/Response'
import Helper from '../services/Helper.js'


export const ProvinceConst = Object.freeze({
  TYPE_TEST: 20,

  map(status: number): string {
    switch (status) {
      case ProvinceConst.TYPE_TEST:
        return 'Test'
    }
    return ''
  },
})


export class Province extends Model {
  declare id: number | null
  created_at: Date | null
  updated_at: Date | null
  name: string | null
  primary_district: number | null
  lat: number | null
  lng: number | null
  accommodation_cost: number | null


  getResourceURL(): string {
    return Helper.setting.province.getResourceAPI
  }

}

export class DataProvincesArray extends DataArray {

  declare data: Province[]
  filter: FilterProvince = new FilterProvince()
}


export class FilterProvince {
  price_group: FilterSet = new FilterSet()
}


export class DataProvince extends DataResource {

  declare data: Province

}
